module.exports = __webpack_public_path__ + "../resources/img/ic-undo.5087a4ac.svg";